<aux-protocol-section
  *ngIf="(isProtocolVersionLoading$ | async) === false"
  className="my-4"
  [versionOptions]="protocolVersionOptions"
  [patientOptions]="patientGroupOptions"
  [hideAmendment]="true"
  [alwaysShowSection]="true"
  (formReady)="onProtocolFormReady($event)"
  [template]="exportButton"
>
</aux-protocol-section>
<ng-template #exportButton>
  <div class="flex justify-between ml-4 mb-4">
    <div class="flex items-center space-x-4">
      <div *ngIf="(this.importSiteCostFF$ | async) === true">
        <aux-button
          variant="secondary"
          icon="upload"
          label="Import Site Cost Data"
          [spinnerSize]="7"
          [onClick]="onImportSiteCostData.bind(this)"
        ></aux-button>
      </div>
      <div *ngVar="isBtnLoading('export') | async as isExportProcessing">
        <aux-button
          variant="secondary"
          icon="file-export"
          [onClick]="this.onExportPatientBudget"
          label="Export"
          [loading]="isExportProcessing"
          [disabled]="isExportProcessing || (loading$ | async)"
          [spinnerSize]="7"
        ></aux-button>
      </div>
    </div>
  </div>
</ng-template>

<ng-container *ngIf="$any(loading$ | async)">
  <div class="border-8 h-32 m-auto mt-40 spinner w-32"></div>
</ng-container>

<div *ngIf="!$any(loading$ | async)">
  <div class="mt-4">
    <aux-patient-budget-table
      [tableType]="
        protocolForm.controls.patientGroup.value === 'invoiceables'
          ? patientTableTypes.INVOICEABLES
          : patientTableTypes.VISITS_COSTS
      "
      [patientGroupId]="
        protocolForm.controls.patientGroup.value === 'invoiceables'
          ? ''
          : protocolForm.controls.patientGroup.value
      "
      (gridApiChanged)="handleGridApi($event)"
    ></aux-patient-budget-table>
  </div>
</div>
